module.exports = __webpack_public_path__ + "fonts/Open_Sans-400-latin-ext17.e21fda7.woff2";